import PropTypes from 'prop-types'

export const PrintCodesIcon = ({title = null}) => (
  <svg
    aria-hidden={!title}
    fill='none'
    height='20px'
    role={title ? 'img' : null}
    viewBox='0 0 20 20'
    width='20px'
    xmlns='http://www.w3.org/2000/svg'>
    {title ? <title>{title}</title> : null}
    <path
      d='M5.6 11.5242C5.4 11.5492 5.2 11.5758 5 11.6042M5.6 11.5242C8.52188 11.1576 11.4781 11.1576 14.4 11.5242M5.6 11.5242L5.28333 15M14.4 11.5242C14.6 11.5492 14.8 11.5758 15 11.6042M14.4 11.5242L14.7167 15L14.9075 17.1025C14.9193 17.2322 14.904 17.363 14.8624 17.4864C14.8209 17.6099 14.7541 17.7233 14.6663 17.8195C14.5785 17.9157 14.4716 17.9926 14.3524 18.0452C14.2332 18.0978 14.1044 18.125 13.9742 18.125H6.02583C5.47417 18.125 5.0425 17.6517 5.0925 17.1025L5.28333 15M5.28333 15H4.375C3.87772 15 3.40081 14.8025 3.04917 14.4508C2.69754 14.0992 2.5 13.6223 2.5 13.125V7.88C2.5 6.97917 3.14 6.20083 4.03083 6.0675C4.56079 5.98823 5.09229 5.9196 5.625 5.86167M14.715 15H15.6242C15.8705 15.0001 16.1144 14.9517 16.342 14.8575C16.5695 14.7633 16.7763 14.6252 16.9505 14.4511C17.1247 14.277 17.2629 14.0703 17.3572 13.8427C17.4515 13.6152 17.5 13.3713 17.5 13.125V7.88C17.5 6.97917 16.86 6.20083 15.9692 6.0675C15.4392 5.98823 14.9077 5.9196 14.375 5.86167M14.375 5.86167C11.4669 5.54525 8.53308 5.54525 5.625 5.86167M14.375 5.86167V2.8125C14.375 2.295 13.955 1.875 13.4375 1.875H6.5625C6.045 1.875 5.625 2.295 5.625 2.8125V5.86167M15 8.75H15.0067V8.75667H15V8.75ZM12.5 8.75H12.5067V8.75667H12.5V8.75Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)

PrintCodesIcon.propTypes = {title: PropTypes.string}
